"use client";

import { Autoplay, Navigation, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import slide from "../assets/slides/slider1.png";
import slide1 from "../assets/slides/slider.png";
import slide2 from "../assets/slides/slider3.png";
import { Link } from "react-router-dom";

export default function Slider() {
  const SLIDES = [
    {
      image: slide,
      head: (
        <p>
          Comprehensive <span className="main-color">Healthcare</span> for Every
          Stage of <span className="main-color">Life</span>
        </p>
      ),
      description:
        "From pediatrics to geriatrics, we offer a full range of services designed to meet the unique needs of every individual at every stage of their journey.",
    },
    {
      image: slide1,
      head: (
        <p>
          Exceptional <span className="main-color">Care</span>, Right When You
          Need It <span className="main-color">Most</span>
        </p>
      ),
      description:
        "With a team of dedicated healthcare professionals and state-of-the-art technology, we're here to deliver reliable and personalized care tailored to your unique health needs.",
    },
    {
      image: slide2,
      head: (
        <p>
          Empowering Your <span className="main-color">Health</span> with
          Innovation and <span className="main-color">Expertise</span>
        </p>
      ),
      description:
        "Combining cutting-edge medical advancements with a patient-first approach, we're redefining healthcare to deliver superior outcomes and exceptional experiences.",
    },
  ];

  return (
    <div>
      <Swiper
        navigation
        effect={"fade"}
        pagination={{ type: "bullets", clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay, EffectFade, Navigation]}
      >
        {SLIDES.map((s, i) => (
          <SwiperSlide key={i}>
            <div className="relative flex items-center">
              <div className="absolute top-0 w-full h-full bg-center bg-no-repeat bg-cover" style={{ backgroundImage: `url(${s.image})` }}></div>
              <div className="relative container pt-28 xl:pt-44 pb-48">
                <div className="max-w-xl flex flex-col gap-6 ms-10">
                  <div className="capitalize font-semibold text-4xl leading-snug">
                    {s.head}
                  </div>
                  <p>{s.description}</p>
                  <div className="flex gap-6 ">
                    <Link to={"/contact"} className="main-btn px-6 py-3">
                      Connect with us
                    </Link>
                    <Link to={"/about"} className="dark-btn px-6 py-3">
                      learn more
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
